import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'
import { ImageService } from '~/services/Misc/ImageService'
import { VacancyNewCardModel } from '~/model/Cards/Vacancy'

export default class AgrocityModel extends BaseModel {
  id: number = 0
  name: string = ''
  region: string = ''
  'region_id': string = ''
  'region_slug': string = ''
  'city_slug': string = ''
  'brief_description': string = ''
  'temperature': number = 0
  'humidity': number = 0
  'wind_speed': number = 0
  'longitude': number = 0
  'latitude': number = 0
  'average_salary': number = 0
  'rent_cost': number = 0
  'population': number = 0
  'life_expectancy': number = 0
  'population_description': string = ''
  'standard_of_living': string = ''
  'history': string = ''
  'infrastructure': string = ''
  'education': string = ''
  'nature': string = ''
  'economy': string = ''
  'culture': string = ''
  'main_photo': string = ''
  'nature_photo_1': string = ''
  'nature_photo_2': string = ''
  'created_at': string = ''
  'updated_at': string = ''
  vacancies: VacancyNewCardModel[] = []
  'vacancies_url': string = ''
  'similar_agrocities': AgrocityModel[] = []
  'agrocity_url': string = ''

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (data.main_photo) {
        this.main_photo = new ImageService().cropImage(data.main_photo, {})
      }

      if (data.nature_photo_1) {
        this.nature_photo_1 = new ImageService().cropImage(data.nature_photo_1, {})
      }

      if (data.nature_photo_2) {
        this.nature_photo_2 = new ImageService().cropImage(data.nature_photo_2, {})
      }

      if (Array.isArray(data.vacancies)) {
        this.vacancies = data.vacancies.map(i => new VacancyNewCardModel(i))
      }

      if (Array.isArray(data.similar_agrocities)) {
        this.similar_agrocities = data.similar_agrocities.map(i => new AgrocityModel(i))
      }
    }
  }
}
